import { vendorReady } from './bootstrap-vendor';

import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

// LIBRARIES
//import { barbaInit } from './modules/barba-init'; // the key

// CRAFTED LIBRARIES
import { calculateViewportHeight } from './modules/utils/calculate-viewport-height'; // calcule viewport height
import { initMenu, closeMenu } from './modules/utils/menu'; // menus
import { jcfReplace } from './modules/utils/jcf-module'; // custom inputs
import { initFormMessages, initNewsLetterForm } from './modules/utils/form-messages'; // forms provider adapter

import { LoadImages } from './modules/utils/load-images'; // lazyload images 
import { initResize } from './modules/utils/resize'; // reinitialize elements on resize (menu case)
import { accordeon } from './modules/utils/accordeon'; // open/close function boxes
import { iniClicksLoading, iniClicksLoadingHeader } from './modules/utils/click'; // feedback on click loading/barba
import { resizeController } from './modules/utils/resize-controller'; // resize screen event controller
import { initHeader, initDesktopMenu } from './modules/utils/header';
import { getLenisScroll } from './modules/utils/lenis-scroll';
import { initFooter } from './modules/utils/footer';
var lessRules = [];

function getGsap() {
  return window.gsap || globalThis.gsap || null;
}

function getScrollTrigger() {
  return window.ScrollTrigger || globalThis.ScrollTrigger || null;
}

function safeRun(label, callback) {
  try {
    callback();
  } catch (error) {
    console.error(`cmpth ${label} failed`, error);
  }
}

async function safeRunAsync(label, callback) {
  try {
    await callback();
  } catch (error) {
    console.error(`cmpth ${label} failed`, error);
  }
}

function revealApp() {
  const app = document.querySelector('#app');
  const viewport = document.querySelector('#viewport');
  const gsapInstance = getGsap();

  if (app) {
    app.style.height = '';
    app.style.overflow = '';

    if (gsapInstance) {
      gsapInstance.to(app, {
        duration: 0.3,
        autoAlpha: 1,
        ease: 'Power2.easeOut',
      });
    } else {
      app.style.opacity = '1';
      app.style.visibility = 'visible';
    }
  }

  if (viewport && gsapInstance) {
    gsapInstance.to(viewport, {
      duration: 0.3,
      autoAlpha: 1,
      ease: 'Power2.easeOut',
    });
  }
}

vendorReady.then(() => {
  jQuery(function () {
    //barbaInit();
    revealApp();

    safeRun('initResize', () => initResize());
    safeRun('initMenu', () => initMenu());
    safeRun('resizeController', () => resizeController());
    safeRun('initDesktopMenu', () => initDesktopMenu());
    safeRun('langBindings', () => {
      document
        .querySelectorAll('.lang a, .lang select')
        .forEach(item => item.setAttribute('data-barba-prevent', 'self'));

      document.querySelectorAll('.lang select').forEach(select => {
        select.addEventListener('change', event => {
          const url = event.target.value;

          if (!url || (!url.startsWith('/') && !url.startsWith('http'))) {
            return;
          }

          window.location.href = url;
        });
      });
    });
  });
});

export function preInit(d = document) {
  closeMenu();
}

async function initDeferredFeatures(d = document) {
  const featureLoaders = [
    {
      label: 'initAnimations',
      test: root => root.querySelector("[data-animation='custom']"),
      load: async root => {
        const { initAnimations } = await import('./modules/utils/customAnimations');
        initAnimations(root);
      },
    },
    {
      label: 'initDropdownCards',
      test: root => root.querySelector('.card-image-content-dropdown .content-hidden, .card-people-dropdown .content-hidden'),
      load: async root => {
        const { initDropdownCards } = await import('./modules/utils/cards');
        initDropdownCards(root);
      },
    },
    {
      label: 'initGalleries',
      test: root => root.querySelector('.splide'),
      load: async root => {
        const { initGalleries } = await import('./modules/utils/galleries');
        initGalleries(root);
      },
    },
    {
      label: 'initTeamPopup',
      test: root => root.querySelector('.team-section .popup'),
      load: async root => {
        const { initTeamPopup } = await import('./modules/utils/initTeamPopup');
        initTeamPopup(root);
      },
    },
    {
      label: 'initTabsSectionMenu',
      test: root => root.querySelector('section.section-tabs .tabs-section-menu'),
      load: async root => {
        const { initSubmenuObserver, initTabsSectionMenu } = await import('./modules/utils/tabs-section-menu');
        initTabsSectionMenu(root);
        initSubmenuObserver(root);
      },
    },
    {
      label: 'initPlyr',
      test: root => root.querySelector('.plyr-instance:not(.header_section .plyr-instance)'),
      load: async root => {
        const { initPlyr } = await import('./modules/utils/video');
        initPlyr(root);
      },
    },
    {
      label: 'initForms',
      test: root => root.querySelector('section.forms-section .tabs-section-menu'),
      load: async root => {
        const [{ initForms }, { initFormsContactSuccess }] = await Promise.all([
          import('./modules/utils/forms-section'),
          import('./modules/utils/forms-contact-success'),
        ]);
        initForms(root);
        initFormsContactSuccess();
      },
    },
    {
      label: 'initValuesSection',
      test: root => root.querySelector('.values-section-menu ul'),
      load: async root => {
        const { initValuesSection } = await import('./modules/utils/values-section');
        initValuesSection(root);
      },
    },
    {
      label: 'initSearchBar',
      test: () => document.querySelector('.header .search, .header .search-mobile, .header-search-bar'),
      load: async () => {
        const { initSearchBar } = await import('./search');
        initSearchBar();
      },
    },
    {
      label: 'initHomeBanner',
      test: root => root.querySelector('button.next-section, .we-section-title'),
      load: async root => {
        const { initHomeBanner } = await import('./modules/utils/home-banner');
        initHomeBanner(root);
      },
    },
    {
      label: 'initNumbers',
      test: root => root.querySelector('.number.animated .number-title'),
      load: async root => {
        const { initNumbers } = await import('./modules/utils/numbers');
        initNumbers(root);
      },
    },
    {
      label: 'initPostShare',
      test: root => root.querySelector('.post-content .post-share'),
      load: async root => {
        const { initPostShare } = await import('./modules/utils/post');
        initPostShare(root);
      },
    },
  ];

  await Promise.all(
    featureLoaders.map(loader =>
      safeRunAsync(loader.label, async () => {
        if (!loader.test(d)) {
          return;
        }

        await loader.load(d);
      })
    )
  );
}

export async function init(d = document) {
  const gsapInstance = getGsap();
  const scrollTriggerInstance = getScrollTrigger();

  safeRun('iniClicksLoading', () => iniClicksLoading(d));
  safeRun('getLenisScroll', () => getLenisScroll(d));
  safeRun('LoadImages', () => LoadImages(d));
  safeRun('calculateViewportHeight', () => calculateViewportHeight());
  safeRun('jcfReplace', () => jcfReplace(d));
  safeRun('initFormMessages', () => initFormMessages());
  safeRun('initHeader', () => initHeader(d));
  safeRun('accordeon', () => accordeon(d));
  safeRun('closeMenu', () => closeMenu());
  safeRun('initFooter', () => initFooter(d));
  safeRun('iniClicksLoadingHeader', () => iniClicksLoadingHeader());
  safeRun('initNewsLetterForm', () => initNewsLetterForm());
  await initDeferredFeatures(d);

  if (gsapInstance) {
    safeRun('revealAppAnimation', () => {
      gsapInstance.to('#app', {
        duration: 0.3,
        autoAlpha: 1,
        ease: 'Power2.easeOut',
      });
    });
  } else {
    revealApp();
  }

  if (scrollTriggerInstance?.refresh) {
    safeRun('ScrollTrigger.refresh', () => scrollTriggerInstance.refresh());
  }
}

window.addEventListener('load', async event => {
  await vendorReady;
  revealApp();
  safeRun('initMenuOnLoad', () => initMenu());
  await safeRunAsync('pageInit', () => init(document.querySelector('main') || document));
});
